module.exports = __webpack_public_path__ + "img/赔偿.a8ec9bf4.png";